import { ArrowDown, ArrowUpRight } from "lucide-react";
import TypeformWidget from "@/components/TypeformWidget";
import { Reveal, scrollTo } from "@/components/Reveal";

const TYPEFORM_URL = "https://form.typeform.com/to/HnbNWHfS";

export default function ApplicationForm() {
  return (
    <section id="apply" className="border-t border-white/10 bg-[#0d0d0d]" data-testid="application-section">
      <div className="mx-auto max-w-3xl px-6 py-16 text-center lg:px-10 lg:py-20">
        <Reveal>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            Apply to work with me <span className="italic text-neutral-400">1-on-1.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-neutral-400">
            I take a small number of private clients — if we're aligned,
            you'll hear from me directly.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-8">
          <div className="mx-auto overflow-hidden border border-white/10 bg-black/40 backdrop-blur-sm" data-testid="application-form">
            <TypeformWidget />
          </div>
          <a
            href={TYPEFORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="application-open-typeform"
            className="group mt-6 inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-300 hover:text-white"
          >
            Prefer a new tab? Open the application
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>

        <Reveal delay={0.2} className="mt-10 flex flex-col items-center gap-6">
          <button
            onClick={() => scrollTo("#apply")}
            data-testid="hero-apply-cta"
            className="btn-shine group relative flex items-center gap-3 overflow-hidden bg-white px-12 py-6 text-sm font-bold uppercase tracking-[0.3em] text-black shadow-[0_0_50px_rgba(255,255,255,0.35)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_0_80px_rgba(255,255,255,0.5)]"
          >
            <span className="absolute inset-0 animate-ping-slow border-2 border-white/60" />
            Apply Now
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </button>
          <p className="text-[11px] uppercase tracking-[0.18em] text-neutral-500 sm:text-xs sm:tracking-[0.25em]" data-testid="hero-apply-note">
            Takes 2 minutes — every application reviewed personally
          </p>
        </Reveal>

        <Reveal delay={0.25} className="mt-10">
          <div
            className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-3"
            data-testid="hero-stats"
          >
            {[
              ["1,000+", "First dates of field research"],
              ["8 weeks", "Average client transformation"],
              ["1-on-1", "Fully private & discreet"],
            ].map(([num, label]) => (
              <div key={label} className="bg-[#0d0d0d] px-6 py-6 text-center">
                <p className="font-serif text-3xl font-light">{num}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-neutral-500">{label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <div className="flex justify-center pt-6">
          <ArrowDown className="h-5 w-5 animate-bounce text-neutral-600" />
        </div>
      </div>
    </section>
  );
}
